export enum SensOperation {
	Credit = 'credit',
	Debit = 'debit'
}

export enum OperationKind {
	Mouvement = 'mouvement',
	Retrait = 'retrait',
	DemandeRib = 'demandeRib'
}

export enum StatutOperation {
	EnAttenteEnregistrementParAvocat = 'enAttenteEnregistrementParAvocat',
	EnAttenteEnregistrementParCarpa = 'enAttenteEnregistrementParCarpa',
	Enregistre = 'enregistre',
	Bloque = 'bloque',
	Valide = 'valide',
	GenereEnLot = 'genereEnLot',
	Rapproche = 'rapproche',
	Consolide = 'consolide',
	Supprime = 'supprime',
	BloquantEnSaisie = 'bloquantEnSaisie',
	BloqueAuto = 'bloqueAuto'
}

export enum StatutCompteBancaire {
	Inactif = 'inactif',
	Actif = 'actif',
	EnCoursCloture = 'enCoursCloture'
}

export enum ComportementTypeCredit {
	None = 'none',
	Annulation = 'annulation',
	AnnulationAvecContrepartieBancaire = 'annulationAvecContrepartieBancaire',
	HorsSoldeAvantRappro = 'horsSoldeAvantRappro',
	Rejet = 'rejet',
	Placement = 'placement'
}

export enum ComportementTypeDebit {
	None = 'none',
	NumLettreCheque = 'numLettreCheque',
	NumLettreChequeAvecValidationEtGeneration = 'numLettreChequeAvecValidationEtGeneration',
	NumLettreChequeCarpaCheque = 'numLettreChequeCarpaCheque',
	Rejet = 'rejet',
	Virement = 'virement',
	Placement = 'placement'
}

export enum TypeOperation {
	Rib = 'rib',
	Mouvement = 'mouvement'
}

export enum TypeOperationCode {
	Annulation = 'AN',
	AnnulationAvecContrepartieBq = 'A2',
	RemiseCheque = 'CH',
	RejetVirement = 'RV',
	RejetCheque = 'RJ',
	Impaye = 'IM',
	Rejet = 'RT',
	Virement = 'VV',
	VirementBancaire = 'VB'
}

export enum NatureOperation {
	A15Credit = '15C',
	A15Debit = '15D',
	VoieExCredit = 'VEXC',
	VoieExDebit = 'VEXD',
	VirementBancaire = 'VIR',
	Annulation = 'ANN',
	AnnulOppoProd = 'AOP',
	RejetCheque = 'REJ',
	RejetVirementEmis = 'RVB',
	RejetVirementRecu = 'RVD',
	Impaye = 'IMP',
	VirementCoreRecu = 'VCR',
	LettreCheque = 'LCE',
	AnnulChequeRac = 'ANRAC',
	AnnulChequePerimeRac = 'ANPRAC',
	RejetChequeRac = 'REJCHQRAC',
	RejetVirementRac = 'REJVIRAC',
	RejetVirementRacDebit = 'REJVIRACD',
	ImpayeRac = 'IMPRAC'
}

export enum SouscriptionCodes {
	SCPTS = 'SCPTS',
	SCPTD = 'SCPTD',
	SCPTS2 = 'SCPTS2'
}

export enum FiltreParametre {
	Options = 'options', //Libelle en IHM
	Impression = 'impression' //Libelle en IHM
}

export enum GenerationOperationType
{
    AnnulationChequeEmis = 'AnnulationChequeEmis',
    AnnulationChequePerime = 'AnnulationChequePerime',
    RejetChequeEmis = 'RejetChequeEmis',
    RejetVirementEmis = 'RejetVirementEmis',
    ImpayeRemise = 'ImpayeRemise',
    RejetVirementRecu = 'RejetVirementRecu',
    LotVirement = 'LotVirement'
}

export enum ActionTypeOpe {
	Annulation = 'annulation',
	Annulation15 = 'annulation15',
	Edit = 'edit',
	Rejet = 'rejet',
	Impaye = 'impaye',
}

export enum EtatApr {
	None = 'none',
	APREncours = 'aprEncours',
	CARPARIBEnAttente = 'carparibEnAttente'
}